import * as React from 'react';
import { notification, Button, Popconfirm } from 'antd';
import { ProductNode, StockReport } from '../../schema';
import { CompanyNodeEdge, Bussiness } from '../master/Company/constants';
import { KhadiPhysicalStockForm } from './KhadiPhysicalStockForm';
import { KhadiPhysicalStockNode, khadiPhysicalStockObject } from './Constants';
import { PhysicalStockService } from '../../service/PhysicalStockService';
import moment from 'moment';

export class KhadiPhysicalStockEntry extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      physicalStock: JSON.parse(JSON.stringify(khadiPhysicalStockObject)),
      buttonDisabled: false,
    };
  }

  physicalStockService = new PhysicalStockService();

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const physicalStock = { ...this.state.physicalStock };
    physicalStock[e.target.name] = e.target.value;
    this.setState({ physicalStock });
  };

  productChangeHandler = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number } },
    index: number,
  ) => {
    const nextState: State = {
      ...this.state,
    };
    if (nextState.physicalStock.productDetails) {
      nextState.physicalStock.productDetails[index][e.target.name] =
        e.target.value;
    }
    this.setState(nextState);
  };

  updateProductsRow = (type: string, index: number) => {
    const nextState: State = { ...this.state };
    if (type === '+') {
      nextState.physicalStock.productDetails?.push({
        date: null,
        productId: '',
        quantity: null,
        rate: 0,
        amount: 0,
        movementType: 'OPENING_STOCK',
        companyId: null,
      });
    } else {
      nextState.physicalStock.productDetails?.splice(index, 1);
    }
    this.setState(nextState);
  };

  productObjChangeHandler = (productObj: ProductNode, index: number) => {
    const nextState = { ...this.state };

    if (nextState.physicalStock.productDetails) {
      nextState.physicalStock.productDetails[index].rate =
        productObj.sellingRate;
      nextState.physicalStock.productDetails[index].quantity = (
        productObj.stock as StockReport
      ).totalStocks;
      nextState.physicalStock.productDetails[index].unitName =
        productObj.unit?.name || '';
      nextState.physicalStock.productDetails[index].materialType =
        productObj.materialType || '';
      nextState.physicalStock.productDetails[index].productName =
        productObj.name || '';
      const physicalStockValue = (productObj as any).physicalStock
        ?.physicalStock;
      if (physicalStockValue !== undefined && physicalStockValue !== null) {
        if (!nextState.physicalStock.physicalStocks) {
          nextState.physicalStock.physicalStocks = [];
        }

        nextState.physicalStock.physicalStocks[index] = physicalStockValue;
      }
      nextState.physicalStock.productDetails[index].stockRemarks =
        (productObj as any).physicalStock?.stockRemarks || null;
      nextState.physicalStock.declarationIsChecked =
        (productObj as any).physicalStock?.declarationIsChecked || false;
    }

    this.setState(nextState);
  };

  physicalQuantityChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const nextState = { ...this.state };
    if (nextState.physicalStock.physicalStocks)
      nextState.physicalStock.physicalStocks[index] = Number(e.target.value);
    this.setState(nextState);
  };

  savePhysicalStock = () => {
    if (!this.state.physicalStock.declarationIsChecked) {
      notification.error({
        message: 'Declaration Required',
        description: 'Please accept the declaration before submitting.',
      });
      return;
    }
    this.setState({ buttonDisabled: true });
    const physicalStock = { ...this.state.physicalStock };
    physicalStock.companyId = this.props.company.id;
    physicalStock.branchId =
      this.props.business.type === 'branch' ? this.props.business.id : null;
    this.physicalStockService?.addKhadiPhysicalStock(
      physicalStock,
      (response) => {
        this.setState({
          physicalStock: JSON.parse(JSON.stringify(khadiPhysicalStockObject)),
        });
        this.setState({ buttonDisabled: false });
        notification.success({
          message: 'Updated',
          description: `Physical Stock Added successfully`,
        });
      },
      (error) => {
        notification.error({
          message: 'Physical Stock Error',
          description: JSON.stringify(error),
        }),
          this.setState({ buttonDisabled: false });
      },
    );
  };

  downloadCsv = () => {
    const { physicalStock } = this.state;
    const escapeCsvValue = (value: string | number | null | undefined) =>
      `"${String(value ?? '').replace(/"/g, '""')}"`;
    const grossValue =
      physicalStock.productDetails?.reduce((total, product, index) => {
        return (
          total +
          (product.rate || 0) * (physicalStock.physicalStocks?.[index] || 0)
        );
      }, 0) || 0;
    const tableHeaders = [
      'Sl. No.',
      'Product',
      'MRP',
      'Available Quantity',
      'Unit',
      'Material Type',
      'Stock Value as per Online Record',
      'Physically Verified Stock as on 31.03.2026',
      'Stock Value Post Verification as on 31.03.2026',
      'Qty Variance',
      'Stock Value Variance',
      'Remarks',
    ];
    const rows = [
      [
        'Date',
        physicalStock.date
          ? moment(physicalStock.date).format('DD-MM-YYYY')
          : '',
      ],
      ['Branch', this.props.business.name],
      ['Gross Value', grossValue],
      [],
      tableHeaders,
      ...(physicalStock.productDetails || []).map((product, index) => {
        const physicalQuantity = physicalStock.physicalStocks?.[index] || 0;
        const availableQuantity = product.quantity || 0;
        const rate = product.rate || 0;
        const onlineStockValue = rate * availableQuantity;

        return [
          index + 1,
          product.productName,
          rate,
          availableQuantity,
          product.unitName,
          product.materialType,
          onlineStockValue,
          physicalQuantity,
          physicalQuantity * rate,
          availableQuantity - physicalQuantity,
          onlineStockValue - physicalQuantity * rate,
          product.stockRemarks,
        ];
      }),
    ];
    const csv = rows
      .map((row) => row.map(escapeCsvValue).join(','))
      .join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'physical-stock-entry.csv';
    link.click();
    window.URL.revokeObjectURL(url);
  };

  clear = () => {
    this.setState({
      physicalStock: JSON.parse(JSON.stringify(khadiPhysicalStockObject)),
    });
  };

  render() {
    return (
      <div>
        <KhadiPhysicalStockForm
          value={this.state.physicalStock}
          onChange={this.onChange}
          productChangeHandler={this.productChangeHandler}
          updateProductsRow={this.updateProductsRow}
          company={this.props.company}
          currentBusiness={this.props.business}
          physicalQuantityChangeHandler={this.physicalQuantityChangeHandler}
          productObjChangeHandler={this.productObjChangeHandler}
        />
        <div style={{ display: 'flex' }}>
          <Button
            icon="download"
            onClick={this.downloadCsv}
            style={{ width: '33.33%' }}
          >
            Download
          </Button>
          <div style={{ width: '33.33%' }}>
            <Popconfirm
              title="Are you sure to clear?"
              onConfirm={this.clear}
              okText="Yes"
              cancelText="No"
            >
              <Button
                type="dashed"
                children="Clear"
                style={{ width: '100%' }}
              />
            </Popconfirm>
          </div>
          <Button
            type="primary"
            onClick={this.savePhysicalStock}
            children="Submit"
            style={{ width: '33.33%' }}
            disabled={this.state.buttonDisabled}
          />
        </div>
      </div>
    );
  }
}

interface Props {
  company: CompanyNodeEdge;
  business: Bussiness;
}

interface State {
  physicalStock: KhadiPhysicalStockNode;
  buttonDisabled: boolean;
}
